import React from "react";
import { CircularProgress } from "@mui/material";

interface InlineLoaderProps {
  size?: number;
  thickness?: number;
  style?: React.CSSProperties;
}

const InlineLoader: React.FC<InlineLoaderProps> = ({
  size = 32,
  thickness = 4,
  style,
}) => (
  <span
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      ...style,
    }}
  >
    <CircularProgress size={size} thickness={thickness} />
  </span>
);

export default InlineLoader;

